import React from 'react'
import styles from 'components/filters/stream-name.module.scss'
import cn from 'classnames'
import useStore from 'state/knovStore'
import SearchIcon from 'components/shared/icons/SearchIcon'
import { homePrivateEnabled } from 'lib/homePrivate'

const teamMatchesFilter = (team, filter) =>
    team?.id && filter?.team_ids?.length && String(team.id) === String(filter.team_ids[0])

export function getStreamName(filter, filterUser, showPublic = false, providedTeam = null) {
    const user = gon.currentUser
    const knovState = useStore.getState()
    const publicUser = knovState.publicUser
    const publicTeams = knovState.publicTeams
    const knovigatorSpace = knovState.knovigatorSpace
    const activeSpaceId = knovState.activeSpaceId
    const userSpaces = knovState.userSpaces

    let streamName

    if (publicUser) {
        streamName = publicUser.name
    } else if (filter && (filter.user || filter.user_ordinals || filter.user_music)) {
        const base = filterUser ? filterUser.name : 'Loading...'
        streamName = filter.user_ordinals
            ? `${base} · Ordinals`
            : filter.user_music
            ? `${base} · Music`
            : base
    } else if (filter && filter.all) {
        streamName = 'All'
    } else if (filter && filter.team_ids && filter.team_ids.length > 0) {
        // For logged-in users, check both user teams and public teams
        // For logged-out users, only check public teams
        const teamsToSearch =
            user && user.space_teams
                ? [...user.space_teams, ...(publicTeams || [])]
                : publicTeams || []
        const team = teamMatchesFilter(providedTeam, filter)
            ? providedTeam
            : teamsToSearch.find(t => String(filter.team_ids[0]) === String(t.id))
        streamName = team && team.name
    } else if (filter && filter.notifications) {
        streamName = 'Notifications'
    } else if (filter?.private_messages || filter?.private_message_requests) {
        // The DMs nav item's feed.
        streamName = 'Direct Messages'
    } else if (filter && filter.private) {
        streamName = homePrivateEnabled() ? 'Home' : 'Private'
    } else if (filter?.link) {
        streamName = 'Link Access'
    } else if (filter?.clip) {
        streamName = 'Clips'
    } else if (filter?.public_clip) {
        streamName = 'Public Clips'
    } else if (filter?.streams && filter?.streams_scope === 'private') {
        streamName = 'Private'
    } else if (filter?.streams) {
        streamName = 'Channels'
    } else if (filter?.memes) {
        streamName = 'Memes'
    } else if (filter?.market) {
        streamName = 'Market'
    } else if (filter?.ordinals) {
        streamName = 'Ordinals'
    } else if (filter?.public || filter?.following) {
        if (filter?.public && showPublic) streamName = 'Public'
        else streamName = 'Home'
    } else if (filter?.hodlocker) {
        streamName = 'Hodlocker'
    } else if (filter?.twetch) {
        streamName = 'Twetch'
    } else if (filter?.treechat) {
        streamName = 'Treechat'
    } else if (filter?.history) {
        streamName = 'History'
    } else if (filter?.starred) {
        streamName = 'Starred'
    } else if (filter?.participants) {
        streamName = 'People'
    } else {
        streamName = gon.currentUser
            ? userSpaces.find(s => String(s.id) === String(activeSpaceId))?.name
            : knovigatorSpace?.name
    }

    return streamName
}

export default function StreamName(props) {
    const filter = props.filter
    //console.log('stream name filter', props.panel, filter)
    const query = props.query
    const streamName = getStreamName(filter, props.filterUser, props.showPublic, props.team)

    const showQuery = props.searchBar
    const nameSearchStyles = showQuery ? styles.nameAndSearch : null
    const showStreamName = !showQuery
    const panelStyles = props.panel === 'right' ? styles.rightPanel : null

    const memeStreamStyles = props.filter?.meme ? styles.memeStream : null

    return (
        <div className={styles.streamNameComp}>
            {showStreamName && (
                <div className={styles.streamNameContainer}>
                    <div
                        className={cn(
                            styles.streamName,
                            nameSearchStyles,
                            memeStreamStyles,
                            props.contextStyles,
                        )}
                    >
                        {streamName}
                    </div>
                </div>
            )}

            {showQuery && (
                <div className={styles.queryContainer}>
                    <div className={cn(styles.queryIcon, panelStyles)}>
                        <SearchIcon />
                    </div>

                    <div className={styles.query}>{query}</div>
                </div>
            )}
        </div>
    )
}
